import React from 'react';
import RecruiterCompleteStep from 'modules/SignUp/components/RecruiterCompleteStep';

const SignUpComplete: React.FC = () => <RecruiterCompleteStep />;

export default SignUpComplete;
